import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import {Button, Select} from "@mui/material";


export default class importdata extends Component {
	
     constructor(props) {
      super(props)
      this.state = {

          open:false,imgCollection: '',type:'',
      }
      
  }
   onFileChange=(e) =>{
	      let imageFile = e.target.files[0];

	   if (!imageFile.name.match(/\.(csv)$/)) {
  alert( 'Please select valid file (csv).' );
    return false;
  }else{
        this.setState({ imgCollection: e.target.files })
  }
        
    }
handleClickOpen = (e) => {

  this.setState({ open:!this.state.open,  });
		


};

 myChangeHandler = (event) => {
	  
	 
	    const re = /^[0-9.\b]+$/;
  let nam = event.target.name;
  let val = event.target.value; 
  
   this.setState({[nam]: val});
 }
handleClose = (e) => {

 

  var formData = new FormData();

  // formData.append('action','importorders')
		 formData.append('action','importlabour') 
		  
	  	 formData.append('type',this.state.type) 
	  if(this.state.imgCollection!='')
	  {
		  
		for (const key of Object.keys(this.state.imgCollection)) {
            formData.append('Filedata', this.state.imgCollection[key])
        } 
		
	  
	 
	  axios.post(Serverurl+"ajaximport.php", formData, {
        }).then(res => {

					    alert("inventory Uploaded Successfully")

            });
  
  this.setState({ open:false });
};
}
render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   
<p>

<Select
				className="inputcntlparent"
				size="small"
				variant="outlined"
				native label="Units"   
				value={this.state.type}
			 onChange={this.myChangeHandler}
				name="type"
				id="Units"
			  >
				<option value={0}>Select Unit</option>
				<option value={1}>Labour amount</option>
				<option value={2}>Pay in</option>
				<option value={3}>Material</option>
				<option value={4}>Expense</option>	
			  </Select></p>
   <p> <input type="file" name="imgCollection" onChange={this.onFileChange} /></p>
   
   <Button className="primarybtn" onClick={this.handleClose} variant="contained">
          Save
        </Button>
 </React.Fragment> 

 
 
  );
}
}
